import { useContext, useEffect, useState } from "react";

import { SdkContext } from "../SdkProvider";

import { useSdk } from "./useSdk";

export const useTokenStorage = () => {
  const { tokenStorage } = useContext(SdkContext);
  const [accessToken, setAccessToken] = useState(
    tokenStorage.tokens?.accessToken,
  );
  const sdk = useSdk();

  useEffect(() => {
    const handle = () => {
      tokenStorage.getTokens().then((res) => {
        setAccessToken(res?.accessToken);
      });
    };

    handle();
    const intervalId = setInterval(handle, 1000);
    sdk.dispatcher.on("auth.token.changed", handle);

    return () => {
      sdk.dispatcher.off("auth.token.changed", handle);
      clearInterval(intervalId);
    };
  }, [sdk.dispatcher, tokenStorage]);

  return {
    ...tokenStorage,
    getTokens: tokenStorage.getTokens,
    setTokens: tokenStorage.setTokens,
    accessToken,
  };
};
